<template>
    <div>
        <div class="wrapper">
            <div class="body">
                <div class="box-horizontal" style="position:fixed; top: 0;right: 0;left: 0;bottom: 0;">
                    <div class="mb20 bg-round-white pt20 pb20 flex-1 mr10 ml10" v-show="!get.data.isSuccess">
                        <div class="dialog-inner ml10 mr10 text-left">
                            <span class="block mb10 hitam">Selamat Datang,</span>
                            <h3 class="mt10 mb20 f17 primary-color">Aplikasi Pelanggan Internet</h3>

                            <span class="block mb10 gray">Silahkan Login terlebih dahulu</span>
                            <input type="number" v-model="get.data.telepon" class="hitam pt10 pb10 w100 mb20 f13" style="border:0; border-bottom:1px solid #333;" placeholder="Telepon...">
                            <input type="password" v-model="get.data.password" class="hitam pt10 pb10 w100 f13 mb20" style="border:0; border-bottom:1px solid #333;" placeholder="Password...">
                            
                            <span class="block mb10 orange text-center" v-show="get.data.kosongText">Telepon dan Password tidak boleh kosong</span>
                            <span class="block mb10 red" v-show="get.data.salah">Telepon dan Password Salah!</span>
                            
                            <div class="box-horizontal no-select" @click="met.ingatBtn()">
                                <input type="checkbox" v-model="get.data.ingat" class="check-ingat"/> <!--  v-model="" -->
                                <span class="ml10 f13">Tetap Login</span>
                            </div>

                            <button class="btn btn-info w100 mb10 mt10" v-show="get.data.afterKlik" @click="get.data.afterKlik = false;met.login()">Submit</button>
                            <button class="btn btn-info w100 mb10" v-show="!get.data.afterKlik">Loading...</button>
                            
                            <span class="block mb20 hitam f12 text-center gray">Telepon dan Password tanyakan pada Layanan Internet yg anda gunakan.</span>

                            <span class="block mb10 hitam f12 text-center gray">Support by</span>
                            <span class="block mb20 f12 text-center primary-color">Beatcom | Males Developer</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                telepon: '',
                password: '',
                isSuccess: false,
                kosongText: false,
                afterKlik: true,
                salah: false,
                ingat: false
            }),
            list() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Bantuan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));

                    if (x.status == true) {
                        this.data.list = x.data;
                    } else {
                        
                    }
                    
                })
            }
        }

        const met = {
            back() {
                window.history.back();
            },
            ingatBtn() {
                get.data.ingat = !get.data.ingat;
                // console.log(get.data.ingat);
            },
            login() {
                
                get.data.salah = false;

                if (get.data.telepon == "") {
                    get.data.afterKlik = true;
                    get.data.kosongText = true;
                    return false;
                }
                if (get.data.password == "") {
                    get.data.afterKlik = true;
                    get.data.kosongText = true;
                    return false;
                }

                get.data.kosongText = false;

                var datax = {
                    telepon: get.data.telepon,
                    password: get.data.password
                };
                
                //console.log(JSON.stringify(datax));
            
                var apiUrl = inter.Login(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    // console.log(JSON.stringify(x));

                    if (x.status == true) {

                        var token = x.data.token;
                        var uid = x.data.uid;

                        console.log(x.data.nama);

                        if(get.data.ingat) {
                            // ingat saya
                            localStorage.setItem('browserToken', token);
                            localStorage.setItem('browserTokenUid', uid);
                            sessionStorage.setItem('browserToken', token);
                            sessionStorage.setItem('browserTokenUid', uid);

                        } else {
                            // lupa ketika ganti tab
                            sessionStorage.setItem('browserToken', token);
                            sessionStorage.setItem('browserTokenUid', uid);
                        }

                        met.beranda();
                        
                    } else {
                        get.data.salah = true;
                        get.data.afterKlik = true;
                        get.data.kosongText = false;

                        // myGlobal.android("toast", "Terjadi Kesalahan")
                        
                    }
                    
                })
            },
            beranda() {
                router.push({ 
                    name: 'beranda'
                });
            }
        }

        return {
            get,
            met
        }

    },
    mounted () {        

        //this.get.list();

        this.get.data.ingat = false;

        if(localStorage.getItem('browserToken') != null) {
            //console.log("Sesi ada "+localStorage.getItem('browserToken'));

            // token ada
            this.met.beranda();
            
            sessionStorage.setItem('browserToken', localStorage.getItem('browserToken'));
            sessionStorage.setItem('browserTokenUid', localStorage.getItem('browserTokenUid'));

        }
    }
}
</script>

<style scoped>
.check-ingat {
    width: 20px;
    height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Login/main.vue